module.exports = __webpack_public_path__ + "static/media/mailarrow.b935079b.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/mailarrow.svg
// module id = 364
// module chunks = 0